import { AuthRoute, AuthUserRoute } from '/@/modules/auth/routes/auth.routes';
import { AuthOnboardingRouteConfig } from '/@/modules/auth/routes/AuthOnboardingRouteConfig';
import { BillingPlanId } from '/@/modules/billing/constants/BillingPlanId';
import { AuthLoginRouteConfig } from '/@/modules/auth/routes/AuthLoginRouteConfig';
import { AuthSsoLoginRouteConfig } from '/@/modules/auth/routes/AuthSsoLoginRouteConfig';

export const router = [
  {
    path: `/${AuthRoute.LOGINLAYOUT.path}`,
    name: AuthRoute.LOGINLAYOUT.name,
    component: () => import('/@/modules/auth/pages/LoginLayout.vue'),
    meta: { guestOnly: true },
    children: [
      {
        path: '/sandbox',
        name: 'sandbox',
        component: () => import('/@/modules/auth/pages/SandboxPage.vue'),
        meta: { guestOnly: true }
      },
      AuthLoginRouteConfig.factory({
        path: `/${AuthRoute.LOGIN.path}`,
        name: AuthRoute.LOGIN.name,
        meta: { guestOnly: true }
      }).build(),
      {
        path: `/${AuthRoute.OTP_LOGIN.path}`,
        name: AuthRoute.OTP_LOGIN.name,
        component: () => import('/@/modules/auth/pages/OtpPage.vue'),
        meta: { guestOnly: true }
      },
      {
        path: `/${AuthRoute.SIGNUP_BASIC.path}`,
        name: AuthRoute.SIGNUP_BASIC.name,
        component: () => import('/@/modules/auth/pages/SelfServePlanSignUpPage.vue'),
        meta: { guestOnly: true },
        props: { billingPlanId: BillingPlanId.INDIVIDUAL_BASIC_PLAN }
      },
      {
        path: `/${AuthRoute.SIGNUP_DIGITALVAULT.path}`,
        name: AuthRoute.SIGNUP_DIGITALVAULT.name,
        component: () => import('/@/modules/auth/pages/SelfServePlanSignUpPage.vue'),
        meta: { guestOnly: true },
        props: { billingPlanId: BillingPlanId.INDIVIDUAL_DIGITAL_VAULT }
      },
      {
        path: `/${AuthRoute.SIGNUP_PARTNERSELFSERVE.path}`,
        name: AuthRoute.SIGNUP_PARTNERSELFSERVE.name,
        component: () => import('/@/modules/auth/pages/PartnerSelfServeSignUpPage.vue'),
        meta: { guestOnly: true }
      },
      {
        path: `/${AuthRoute.SIGNUP_AFTERCARE.path}`,
        name: AuthRoute.SIGNUP_AFTERCARE.name,
        component: () => import('/@/modules/auth/pages/AftercareSignUpPage.vue'),
        meta: { guestOnly: true }
      },
      {
        path: `/${AuthRoute.SIGNUP_STANDARD.path}`,
        name: AuthRoute.SIGNUP_STANDARD.name,
        component: () => import('/@/modules/auth/pages/SelfServePlanSignUpPage.vue'),
        meta: { guestOnly: true },
        props: { billingPlanId: BillingPlanId.INDIVIDUAL_STANDARD_PLAN }
      },
      {
        path: `/${AuthRoute.SIGNUP_VAULT.path}`,
        name: AuthRoute.SIGNUP_VAULT.name,
        component: () => import('/@/modules/auth/pages/PlanningSignUpPage.vue'),
        meta: { guestOnly: true }
      },
      {
        path: `/${AuthRoute.SIGNUP_SETTLEMENT.path}`,
        name: AuthRoute.SIGNUP_SETTLEMENT.name,
        component: () => import('/@/modules/auth/pages/SettlementSignUpPage.vue'),
        meta: { guestOnly: true }
      },
      {
        path: `/${AuthRoute.SIGNUP_ADVISOR.path}/:companyName?`,
        name: AuthRoute.SIGNUP_ADVISOR.name,
        component: () => import('/@/modules/auth/pages/SsoSignUpPage.vue'),
        meta: { guestOnly: true },
        props: true
      },
      {
        path: `/${AuthRoute.SIGNUP_ADVISOR_PORTAL.path}`,
        name: AuthRoute.SIGNUP_ADVISOR_PORTAL.name,
        component: () => import('/@/modules/auth/pages/AdvisorSignUpPage.vue'),
        meta: { guestOnly: true }
      },
      {
        path: `/${AuthRoute.VERIFY.path}`,
        name: AuthRoute.VERIFY.name,
        component: () => import('/@/modules/auth/pages/VerifyPage.vue')
      },
      {
        path: `/${AuthRoute.INVITED.path}`,
        name: AuthRoute.INVITED.name,
        component: () => import('/@/modules/auth/pages/InvitedPage.vue')
      },
      {
        path: `/${AuthRoute.FORGOTPASSWORD.path}`,
        name: AuthRoute.FORGOTPASSWORD.name,
        component: () => import('/@/modules/auth/pages/ForgotPasswordPage.vue'),
        meta: { guestOnly: true }
      },
      {
        path: `/${AuthRoute.RESETPASSWORD.path}`,
        name: AuthRoute.RESETPASSWORD.name,
        component: () => import('/@/modules/auth/pages/ResetPasswordPage.vue'),
        meta: { guestOnly: true }
      },
      AuthSsoLoginRouteConfig.factory({
        path: `/${AuthRoute.SSO_LOGIN.path}`,
        name: AuthRoute.SSO_LOGIN.name,
        meta: { guestOnly: true }
      }).build(),
      {
        path: '/auth/:provider/callback',
        component: {
          template: '<div class="auth-component">Login in with Facebook</div>'
        }
      },
      {
        path: `/${AuthUserRoute.ONBOARDING.path}`,
        name: AuthUserRoute.ONBOARDING.name,
        component: () => import('/@/modules/auth/pages/TriageLayoutPage.vue'),
        meta: { authOnly: true },
        children: [
          AuthOnboardingRouteConfig.factory({
            path: AuthUserRoute.ONBOARDING_FLOW.path,
            name: AuthUserRoute.ONBOARDING_FLOW.name,
            component: () => import('/@/modules/auth/components/AuthOnboardingPage.vue'),
            meta: { authOnly: true }
          }).build()
        ]
      },
      {
        path: `/${AuthUserRoute.VERIFY_EMAIL.path}`,
        name: AuthUserRoute.VERIFY_EMAIL.name,
        component: () => import('/@/modules/auth/pages/EmailVerificationSentPage.vue'),
        meta: { authOnly: true }
      },
      {
        path: `/${AuthUserRoute.ESTATE_SELECTION.path}`,
        name: AuthUserRoute.ESTATE_SELECTION.name,
        component: () => import('/@/modules/auth/pages/EstateSelectionPage.vue'),
        meta: { authOnly: true }
      },
      {
        path: `/${AuthUserRoute.OTP_SETUP.path}`,
        name: AuthUserRoute.OTP_SETUP.name,
        component: () => import('/@/modules/auth/pages/OtpSetupPage.vue'),
        meta: { authOnly: true }
      }
    ]
  }
];
